import React from 'react';
import _ from 'lodash';
import { FormattedNumber, FormattedMessage } from 'react-intl';
export default function formatMessageWithPrice(id, info) {
    var minimumFractionDigits = _.get(info, 'digits', _.isInteger(info.price) ? 0 : 2);
    return (React.createElement(FormattedNumber, { value: info.price, style: "currency", currency: info.currency, minimumFractionDigits: minimumFractionDigits }, function (price) { return (React.createElement(FormattedMessage, { id: id, defaultMessage: id, values: { price: price } })); }));
}
